<template>
    <div class="page-address-contract-info">
        <span class="page-address-contract-info__block">
            <!--<ui-link v-if="resolvedValue" v-bind:to="routerParams">-->
            <!--    {{displayedDomain}}-->
            <!--</ui-link>-->

            <span v-text="displayedDomain"/>

            <ui-copy-button v-bind:copy="displayedDomain" style="margin: 0 0 -1px 3px;"/>
        </span>

        <span class="page-address-contract-info__block" v-if="auctionActive">
            <i18n path="address.contract_type.sale.sale_info" tag="span" class="muted">
                <a target="_blank" ref="nofollow"
                    v-bind:href="`https://dns.ton.org/#${domainName}`"
                    v-text="$t('address.contract_type.sale.on_auction')"/>

                <template>{{$ton(currentPrice)}} TON</template>
            </i18n>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        domainName: {
            type: String,
            requried: true,
        },
        resolvedValue: String,
        auctionActive: Boolean,
        auction: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        routerParams() {
            if (!this.resolvedValue) {
                return undefined;
            }

            return Object.freeze({
                name: 'address',
                params: {
                    address: this.resolvedValue,
                },
            });
        },

        displayedDomain() {
            let domain = this.domainName;

            if (domain.length >= 28) {
                domain = domain.substr(0, 12) + '…' + domain.substr(domain.length - 6);
            }

            return domain + '.ton';
        },

        currentPrice() {
            return this.auction.top_bid * 1.05;
        },
    },
};
</script>
